export function EnumDescription(description: string) {
  return function (target: any, propertyKey: string) {
    // Verificar se existe uma propriedade '_Enuns' no prototype da classe
    if (!target.constructor.prototype._Enuns) {
      target.constructor.prototype._Enuns = {};
    }

    // Verificar se o nome do enum já existe dentro de _Enuns
    if (!target.constructor.prototype._Enuns[target.name]) {
      target.constructor.prototype._Enuns[target.name] = {
        _descriptions: {}
      };
    }

    // Adicionar a descrição ao objeto _descriptions com a chave sendo a propriedade do enum
    target.constructor.prototype._Enuns[target.name]._descriptions[propertyKey] = description;
  };
}
